<div class="table-container">

    <app-p-ticket-filter (httpFilterList)="initTableData($event)" [persistInLocalStorage]="true"
        #ticketFilter></app-p-ticket-filter>
    <mat-tab-group mat-stretch-tabs="true" style="height: 100%;">
        <mat-tab label="tCC Tickets">
            <div class="actions-bar">

                <button mat-button (click)="onAddReport()">
                    <mat-icon>equalizer</mat-icon>New report
                </button>

                <button mat-raised-button color="primary" (click)="onNewTicket('tCC')" [disabled]="!canCreateTicket">
                    <mat-icon>add</mat-icon>New ticket
                </button>

            </div>


            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">

                <mat-form-field appearance="fill" class="filter-field">
                    <mat-label>Search tickets</mat-label>
                    <input type="text" [(ngModel)]="tccSearchbarEntry" matInput
                        (keyup)="applyFilter($event, tccDataSource)" placeholder="e.g. Name, Mail" />
                </mat-form-field>
                <span class="example-spacer"></span>
                <button mat-icon-button [matMenuTriggerFor]="tccMenu"
                    matTooltip="Table settings"><mat-icon>settings</mat-icon></button>
                <button mat-icon-button matTooltip="Download table"
                    (click)="exporter.exportTable('csv', {fileName: 'tCC_ticket_selection'})">
                    <mat-icon>save_alt</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Reload table"
                    (click)="ngOnInit()"><mat-icon>refresh</mat-icon></button>
            </div>





            <div class="table-wrapper" [hidden]="isLoading || tccDataSource.data.length == 0">
                <table mat-table matTableExporter #exporter="matTableExporter" [dataSource]="tccDataSource" matSort
                    #tccSort="matSort" class="ticket-table">
                    <ng-container *ngFor="let chip of tccChips" [matColumnDef]="chip.value">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ chip.display }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="(chip.display != 'Actions') && (chip.display != 'Ticket Id')">
                                {{ element[chip.value] }}
                            </div>
                            <div *ngIf="chip.display == 'Actions'">
                                <button mat-icon-button color="secondary" [matMenuTriggerFor]="tccActionMenu"
                                    [matMenuTriggerData]="{data: element}"
                                    (click)="$event.stopPropagation()" [disabled]="element['pct_organization'] != currentUser.getUser().org_name"><mat-icon>more_vert</mat-icon></button>
                            </div>
                            <div *ngIf="chip.display == 'Ticket Id'" style="display: flex;align-items:center">
                                {{ element[chip.value] }}
                                <mat-icon style="scale: 0.65"
                                    matTooltip="This ticket ({{ element['pct_organization'] }}) does not belong to your current organization. Editing is disabled."
                                    color="primary"
                                    *ngIf="element['pct_organization'] != currentUser.getUser().org_name">warning</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="tccDisplayedColumns" class="mat-header-row"></tr>
                    <tr mat-row class="table-row" *matRowDef="let row; columns: tccDisplayedColumns;"
                        (click)="onEdit(row.id)" class="mat-row"></tr>
                    <!-- [routerLink]="'../../pTicket/' + row.id" -->
                </table>
            </div>
            <div class="loading-wrapper" *ngIf="isLoading">
                <mat-spinner></mat-spinner>
            </div>
            <div class="loading-wrapper" *ngIf="!isLoading && tccDataSource.data.length == 0">
                <div><mat-icon color="primary" style="transform: scale(2); margin-bottom: 10px;">cloud_off</mat-icon>
                </div>
                <div>No tickets match your filter</div>
            </div>


            <div class="paginator-container">
                <mat-paginator #tccPaginator="matPaginator" [pageSizeOptions]="[30, 20, 10]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </mat-tab>
        <mat-tab label="pCC Tickets">

            <div class="actions-bar">
                <button mat-raised-button color="primary" (click)="onNewTicket('pCC')" [disabled]="!canCreateTicket">
                    <mat-icon>add</mat-icon>New ticket
                </button>


            </div>

            <div style="display: flex; flex-direction: row; align-items: center; justify-content: center;">

                <mat-form-field appearance="fill" class="filter-field">
                    <mat-label>Search tickets</mat-label>
                    <input type="text" matInput [(ngModel)]="pccSearchbarEntry"
                        (keyup)="applyFilter($event, pccDataSource)" placeholder="e.g. Name, Mail" />
                </mat-form-field>
                <span class="example-spacer"></span>
                <button mat-icon-button [matMenuTriggerFor]="pccMenu"
                    matTooltip="Table settings"><mat-icon>settings</mat-icon></button>
                <button mat-icon-button matTooltip="Reload table"
                    (click)="ngOnInit()"><mat-icon>refresh</mat-icon></button>
            </div>


            <div class="table-wrapper" [hidden]="isLoading || pccDataSource.data.length == 0">

                <table mat-table [dataSource]="pccDataSource" matSort #pccSort="matSort" class="ticket-table">
                    <ng-container *ngFor="let chip of pccChips" [matColumnDef]="chip.value">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{ chip.display }}
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <div *ngIf="(chip.display != 'Actions') && (chip.display != 'Ticket Id')">
                                {{ element[chip.value] }}
                            </div>
                            <div *ngIf="chip.display == 'Actions'">
                                <button mat-icon-button color="secondary" [matMenuTriggerFor]="pccActionMenu"
                                    [matMenuTriggerData]="{data: element}"
                                    (click)="$event.stopPropagation()" [disabled]="element['pct_organization'] != currentUser.getUser().org_name"><mat-icon>more_vert</mat-icon></button>
                            </div>
                            <div *ngIf="chip.display == 'Ticket Id'" style="display: flex;align-items:center">
                                {{ element[chip.value] }}
                                <mat-icon style="scale: 0.65"
                                    matTooltip="This ticket ({{ element['pct_organization'] }}) does not belong to your current organization. Editing is disabled."
                                    color="primary"
                                    *ngIf="element['pct_organization'] != currentUser.getUser().org_name">warning</mat-icon>
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="pccDisplayedColumns" class="mat-header-row"></tr>
                    <tr mat-row class="table-row" *matRowDef="let row; columns: pccDisplayedColumns;"
                        (click)="onEdit(row.id)" class="mat-row"></tr>
                </table>
            </div>
            <div class="loading-wrapper" *ngIf="isLoading">
                <mat-spinner></mat-spinner>
            </div>
            <div class="loading-wrapper" *ngIf="!isLoading && pccDataSource.data.length == 0">
                <div><mat-icon color="primary" style="transform: scale(2); margin-bottom: 10px;">cloud_off</mat-icon>
                </div>
                <div>No tickets match your filter</div>
            </div>


            <div class="paginator-container">
                <mat-paginator #pccPaginator="matPaginator" [pageSizeOptions]="[30, 20, 10]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </mat-tab>

    </mat-tab-group>

</div>




<mat-menu #tccMenu="matMenu">
    <ng-template matMenuContent>
        <button mat-menu-item *ngFor="let tccchip of tccChips" (click)="$event.stopPropagation()">
            {{ tccchip.display }}<mat-icon *ngIf="tccchip.selected" color="primary"
                (click)="toggleSelection('tcc', tccchip)">visibility</mat-icon>
            <mat-icon *ngIf="!tccchip.selected" (click)="toggleSelection('tcc', tccchip)">visibility_off</mat-icon>
        </button>
    </ng-template>

</mat-menu>

<mat-menu #pccMenu="matMenu">
    <button mat-menu-item *ngFor="let pccchip of pccChips" (click)="$event.stopPropagation()">
        {{ pccchip.display }}<mat-icon *ngIf="pccchip.selected" color="primary"
            (click)="toggleSelection('pcc', pccchip)">visibility</mat-icon>
        <mat-icon *ngIf="!pccchip.selected" (click)="toggleSelection('pcc', pccchip)">visibility_off</mat-icon>
    </button>
</mat-menu>

<mat-menu #tccActionMenu="matMenu">
    <ng-template matMenuContent let-data="data">
        <button mat-menu-item [disabled]="!canCreateTicket"
            (click)="onDuplicateTicket(data)" >Duplicate<mat-icon>control_point_duplicate</mat-icon></button>
        <button mat-menu-item [mat-menu-trigger-for]="movingOrgMenu" [matMenuTriggerData]="{data: data}" [disabled]="!canMoveTicket"><mat-icon>arrow_upward</mat-icon>Move to Org</button>
    </ng-template>
</mat-menu>

<mat-menu #pccActionMenu="matMenu">
    <ng-template matMenuContent let-data="data">
        <button mat-menu-item [disabled]="!canCreateTicket"
            (click)="onDuplicateTicket(data)">Duplicate<mat-icon>control_point_duplicate</mat-icon></button>
        <button mat-menu-item><mat-icon>arrow_upward</mat-icon>Move to tCC</button>
    </ng-template>
</mat-menu>

<mat-menu #movingOrgMenu="matMenu">
    <ng-template matMenuContent let-data="data" >
        <button *ngFor="let org of allOrganizations" mat-menu-item (click)="onMoveToOrg(data, org.org_name)">{{org.org_name}}</button>
    </ng-template>
</mat-menu>